module.exports = __webpack_public_path__ + "media/images/image_checkin_info3-c053bd42ac0bdd2ecec68328e1d0bc2d.jpg";